import * as React from 'react';
import S from 's-js';
import SuperCritical from 'lib/supercritical';
import { ConvertedMeasurement } from 'lib/ConvertedMeasurement';
import { NullableNumericInput } from 'portcall/numericinput/view';

interface ConvertedMeasurementParams {
    model : ConvertedMeasurement,
    disabled? : boolean,
    tabindex? : number,
    placeholder? : string
    onFocus? : () => void;
    onBlur? : () => void;
}

export const ConvertedMeasurementView = SuperCritical(({ model, disabled = false, tabindex, onFocus, onBlur: _onBlur, placeholder } : ConvertedMeasurementParams) => 
    <NullableNumericInput className="convertedmeasurement-input"
        value={model.Num}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={() => onBlur({ model, _onBlur })}
        tabindex={tabindex}
        placeholder={placeholder}
    />
);

function onBlur({ model, _onBlur } : { model : ConvertedMeasurement, _onBlur? : () => void }) {
    S.freeze(() => {
        model.RelinquishWriter();
        _onBlur && _onBlur();
    });
}


// WEBPACK FOOTER //
// ./apps/portcall/convertedmeasurement/view.tsx